import BaseService from '@/shared/services/core/base.service';
import { SERVICE_NAMES } from '@/shared/services/core/service-names';

class KnowledgeService extends BaseService {
  async ask(question) {
    const response = await this.repository.ask(question);
    return this.handleResponse(response);
  }
}

export default new KnowledgeService(SERVICE_NAMES.KNOWLEDGE);
